var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.668 13.2776L15.741 9.20431C15.8795 9.06598 16.0535 8.99514 16.2632 8.99181C16.4727 8.98864 16.65 9.05948 16.795 9.20431C16.9398 9.34931 17.0122 9.52498 17.0122 9.73131C17.0122 9.93764 16.9398 10.1133 16.795 10.2583L12.3007 14.7526C12.207 14.8461 12.1083 14.9121 12.0045 14.9506C11.9006 14.9891 11.7885 15.0083 11.668 15.0083C11.5475 15.0083 11.4353 14.9891 11.3315 14.9506C11.2276 14.9121 11.1289 14.8461 11.0352 14.7526L6.54096 10.2583C6.40262 10.1198 6.33179 9.94573 6.32846 9.73606C6.32529 9.52656 6.39612 9.34931 6.54096 9.20431C6.68596 9.05948 6.86162 8.98706 7.06796 8.98706C7.27429 8.98706 7.44995 9.05948 7.59496 9.20431L11.668 13.2776Z",
    fill: "#101014"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownBlack);
export default __webpack_public_path__ + "static/media/down_black.1f3cb4d92da4555b27a422f1416cf43c.svg";
export { ForwardRef as ReactComponent };